// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_server_message_on__ZpKdp {
  width: 100%;
  height: 50px;
  left: 0;
  position: fixed;
  top: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
}

.styles_server_message_under__hNjnU {
  width: 100%;
  height: 50px;
  left: 0;
  position: fixed;
  top: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: -1;
}

.styles_server_message_child_show__kwYy6 {
  height: 100%;
  width: 300px;
  padding: 0 25px 0 25px;
  /* background-color: #e30813; */
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.3s ease-in-out;
  border-radius: 5px;
  color: #ffff;
}

.styles_server_message_child_para_show__WC0NN {
  transition: all 0.8s ease-in-out;
  opacity: 2;
}

.styles_server_message_child_hide__LQM4x {
  height: 100%;
  width: 0;
  background-color: gray;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transition: all 0.3s ease-in-out;
  border-radius: 5px;
  color: #ffff;
}

.styles_server_message_child_para_hide__Kd06L {
  opacity: 0;
}`, "",{"version":3,"sources":["webpack://./../src/renderer/components/AppMessage/styles.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,OAAO;EACP,eAAe;EACf,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,OAAO;EACP,eAAe;EACf,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,+BAA+B;EAC/B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,QAAQ;EACR,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,gCAAgC;EAChC,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,UAAU;AACZ","sourcesContent":[".server_message_on {\n  width: 100%;\n  height: 50px;\n  left: 0;\n  position: fixed;\n  top: 70px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1;\n}\n\n.server_message_under {\n  width: 100%;\n  height: 50px;\n  left: 0;\n  position: fixed;\n  top: 70px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: -1;\n}\n\n.server_message_child_show {\n  height: 100%;\n  width: 300px;\n  padding: 0 25px 0 25px;\n  /* background-color: #e30813; */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  transition: all 0.3s ease-in-out;\n  border-radius: 5px;\n  color: #ffff;\n}\n\n.server_message_child_para_show {\n  transition: all 0.8s ease-in-out;\n  opacity: 2;\n}\n\n.server_message_child_hide {\n  height: 100%;\n  width: 0;\n  background-color: gray;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  opacity: 0;\n  transition: all 0.3s ease-in-out;\n  border-radius: 5px;\n  color: #ffff;\n}\n\n.server_message_child_para_hide {\n  opacity: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"server_message_on": `styles_server_message_on__ZpKdp`,
	"server_message_under": `styles_server_message_under__hNjnU`,
	"server_message_child_show": `styles_server_message_child_show__kwYy6`,
	"server_message_child_para_show": `styles_server_message_child_para_show__WC0NN`,
	"server_message_child_hide": `styles_server_message_child_hide__LQM4x`,
	"server_message_child_para_hide": `styles_server_message_child_para_hide__Kd06L`
};
export default ___CSS_LOADER_EXPORT___;
